import { ErpDataTableV2 } from '@/components/custom/erp';
import { historyColumns } from '../../cols-definition';
import { useRows } from '@/hooks';

export const HistoryTab = () => {
  const { selectedRowIndex, handleRowClick } = useRows();

  const tables = [
    {
      name: '',
      rows: [],
      columns: historyColumns
    }
  ];

  return <ErpDataTableV2 tables={tables} selectedRowId={selectedRowIndex || undefined} onRowClick={handleRowClick} />;
};
